import Icon from '../components/Icon.vue'

Icon.register({
  'prescription-bottle-alt': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M360 0c13.2 0 24 10.8 24 24v48c0 13.2-10.8 24-24 24h-336c-13.2 0-24-10.8-24-24v-48c0-13.2 10.8-24 24-24h336zM32 480v-352h320v352c0 17.6-14.4 32-32 32h-256c-17.6 0-32-14.4-32-32zM96 296v48c0 4.4 3.6 8 8 8h56v56c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-56h56c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-56v-56c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v56h-56c-4.4 0-8 3.6-8 8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/prescription-bottle-alt.js
// module id = 1661
// module chunks = 0